export enum DashboardTypeEnum {
	TOTAL_PERFORMANCE = "TOTAL_PERFORMANCE",
	TOTAL_VOLUMES = "TOTAL_VOLUMES",
	FUEL_VOLUME_OVERVIEW = "FUEL_VOLUME_OVERVIEW",
	LOCATION_PERFORMANCE = "LOCATION_PERFORMANCE"
}